// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__Z6P5y","fullWidth":"FAQ_fullWidth__Pb_9h","title":"FAQ_title__DWCZt"};